/* eslint-disable */
import { motion } from "framer-motion";

const HomePageInnerTableRow = (props) => {
  const {
    data,
    heights = "30px",
    goToPlayerProfilePage,
    goToOrganisationProfilePage,
    clickHandler,
    performanceType,
    timeframe,
  } = props;

  const widthOutput = screen.width;

  const getOverviewValue = (item, key) => {
    const value =
      item.overview[key]?.[
        `${timeframe}${
          !item.isPlayer && performanceType === "Avg" ? "Avg" : ""
        }${performanceType}`
      ];
    return value ? value.toFixed(1) : "-";
  };

  return (
    <>
      {data.length > 0 ? (
        <>
          {data.map((item, i) => (
            <motion.tr
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.6,
                delay: 0.07 * i,
                ease: [0, 0.71, 0.2, 1.01],
              }}
              style={{ marginBottom: "0.5rem" }}
              height={heights}
              key={i}
              id={
                item.playerID ? `player-${item.playerID}` : `org-${item.orgID}`
              }
              className={`table-row-color table-row-items ${
                !item.isPlayer ? "td-items-org" : ""
              }`}
            >
              <td
                className="home-table-row home-table-row-head"
                onClick={() =>
                  item.isPlayer
                    ? goToPlayerProfilePage?.(item.playerID)
                    : goToOrganisationProfilePage?.(item.orgID)
                }
              >
                <th>
                  {widthOutput > 820
                    ? item.player
                    : item.player
                        .split(" ")
                        .map((word) => word[0])
                        .join("")}
                </th>
              </td>

              {/* Performance Data Cells */}
              {["4", "10", "14", "5", "load", "gait"].map((key) => (
                <td
                  key={key}
                  className="home-table-row home-table-row-item"
                  onClick={() => item.isPlayer && clickHandler(item)}
                >
                  <th>{getOverviewValue(item, key)}</th>
                </td>
              ))}
            </motion.tr>
          ))}
        </>
      ) : (
        <tr>
          <td className="td-items">No Players Found</td>
        </tr>
      )}
    </>
  );
};

export default HomePageInnerTableRow;
